// src/components/molecules/AuthFooter/AuthFooter.tsx
import React from 'react';
import { Link } from '@tanstack/react-router';
import { Image } from 'shared-portal-components-v2';

const AuthFooter: React.FC = () => (
  <>
    <div className="text-center text-xs text-muted-foreground">
      <span>By signing in, you agree to our </span>
      <Link
        to="/terms"
        className="inline-flex items-center justify-center gap-2 whitespace-nowrap p-0 text-xs font-medium text-primary underline"
      >
        Terms of Service
      </Link>
      <span> and </span>
      <Link
        to="/privacy"
        className="inline-flex items-center justify-center gap-2 whitespace-nowrap p-0 text-xs font-medium text-primary underline"
      >
        Privacy Policy
      </Link>
    </div>

    <div className="flex justify-center pt-6">
      <Image
        src="/logos/SIX3ROlogo.webp"
        alt="SIX3RO"
        className="h-12 w-auto transition-all duration-300"
      />
    </div>
  </>
);

export default AuthFooter;
